import PropTypes from 'prop-types';
import { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import UIFolderNav from 'UIComponents/nav/UIFolderNav';
import UIFolderNavItem from 'UIComponents/nav/UIFolderNavItem';
import { getHomeFolder } from '../utils/FoldersAndFiles';
import { ROOT_FOLDER_ID } from '../Constants';
import RestrictedAccessIcon from './RestrictedAccessIcon';
import FolderMapProp, { FolderMapsByIdProp } from '../types/props/FolderMapProp';
import TeamsProp from '../types/props/TeamsProp';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  ancestors: ImmutablePropTypes.orderedMap.isRequired,
  exclusions: ImmutablePropTypes.set.isRequired,
  onSelect: PropTypes.func.isRequired,
  fetchFoldersByParentId: PropTypes.func.isRequired,
  selectedFolder: FolderMapProp,
  canUsePartitioning: PropTypes.bool.isRequired,
  tree: PropTypes.object.isRequired,
  folders: FolderMapsByIdProp,
  fetchTeams: PropTypes.func.isRequired,
  teams: TeamsProp,
  isTeamsRequestSucceeded: PropTypes.bool.isRequired
};
export default class FolderTree extends Component {
  constructor(...args) {
    super(...args);
    this.handleHomeClick = () => {
      const {
        onSelect
      } = this.props;
      onSelect(getHomeFolder());
    };
    this.renderFolder = folder => {
      const {
        onSelect,
        ancestors,
        exclusions,
        selectedFolder,
        canUsePartitioning,
        fetchTeams,
        teams,
        isTeamsRequestSucceeded
      } = this.props;
      if (exclusions.contains(folder.id)) {
        return null;
      }
      const children = folder.children;
      const handleClick = () => {
        onSelect(this.getFolder(folder.id));
      };
      const open = selectedFolder.get('id') === folder.id || ancestors.has(folder.id);
      return /*#__PURE__*/_jsx(UIFolderNavItem, {
        className: "folder-tree-item",
        value: folder.id,
        title: folder.name,
        active: selectedFolder.get('id') === folder.id,
        open: open,
        onClick: handleClick,
        iconLeft: open && children ? 'folderOpen' : 'folder',
        iconRight: canUsePartitioning && folder.teams.length && /*#__PURE__*/_jsx(RestrictedAccessIcon, {
          folder: Immutable.Map(folder),
          fetchTeams: fetchTeams,
          teams: teams,
          isTeamsRequestSucceeded: isTeamsRequestSucceeded
        }),
        children: children && children.length > 0 && this.renderChildren(children)
      }, folder.id);
    };
  }
  componentDidMount() {
    this.props.fetchFoldersByParentId(ROOT_FOLDER_ID);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedFolder !== this.props.selectedFolder) {
      this.props.fetchFoldersByParentId(this.props.selectedFolder.get('id'));
    }
  }
  getFolder(id) {
    const {
      folders
    } = this.props;
    return folders.get(id);
  }
  renderChildren(children) {
    return children.map(this.renderFolder);
  }
  render() {
    const {
      selectedFolder,
      tree
    } = this.props;
    return /*#__PURE__*/_jsx(UIFolderNav, {
      "aria-label": tree.name,
      children: /*#__PURE__*/_jsx(UIFolderNavItem, {
        className: "folder-tree-item",
        open: true,
        active: selectedFolder === getHomeFolder(),
        title: tree.name,
        onClick: this.handleHomeClick,
        children: this.renderChildren(tree.children)
      })
    });
  }
}
FolderTree.propTypes = propTypes;
FolderTree.defaultProps = {
  exclusions: Immutable.Set()
};